// extracted by mini-css-extract-plugin
module.exports = {"icon":"Icon-module__icon___qPni5"};